import { render } from "./pb-blockimagetextoffset.vue?vue&type=template&id=fdec54b8"
import script from "./pb-blockimagetextoffset.vue?vue&type=script&lang=js"
export * from "./pb-blockimagetextoffset.vue?vue&type=script&lang=js"

import "./pb-blockimagetextoffset.vue?vue&type=style&index=0&id=fdec54b8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__